import { useId } from "react";

export function LogoMark({ size = 34 }) {
  const id = useId().replace(/:/g, "");
  const u = (n) => `${n}-${id}`;
  const HEX = "32,3 57,17.5 57,46.5 32,61 7,46.5 7,17.5";
  const BLUE = "21.5,16.5 47.5,42.5 42.5,47.5 16.5,21.5";
  const GREEN = "M15.5 43.5 L35.5 23.5 L32.3 20.3 L49 15 L43.7 31.7 L40.5 28.5 L20.5 48.5 Z";
  return (
    <span className="rx-mark-wrap" style={{ width: size, height: size }}>
      <svg viewBox="0 0 64 64" width={size} height={size} className="rx-mark" aria-label="Robo-X logo" role="img">
        <defs>
          <linearGradient id={u("frame")} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#E9FFF3" /><stop offset=".35" stopColor="#7DFFB2" />
            <stop offset=".65" stopColor="#3FA9FF" /><stop offset="1" stopColor="#C9E6FF" />
          </linearGradient>
          <linearGradient id={u("glass")} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#0F2A22" /><stop offset=".55" stopColor="#07131C" /><stop offset="1" stopColor="#040A12" />
          </linearGradient>
          <linearGradient id={u("green")} x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#00C853" /><stop offset=".55" stopColor="#00FF66" /><stop offset="1" stopColor="#D4FFE6" />
          </linearGradient>
          <linearGradient id={u("blue")} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#7FD8FF" /><stop offset=".45" stopColor="#00A3FF" /><stop offset="1" stopColor="#0047CC" />
          </linearGradient>
          <linearGradient id={u("gloss")} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#fff" stopOpacity=".28" /><stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <linearGradient id={u("shine")} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#fff" stopOpacity="0" /><stop offset=".5" stopColor="#fff" stopOpacity=".55" /><stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <clipPath id={u("clip")}><polygon points={HEX} /></clipPath>
        </defs>
        <polygon points={HEX} transform="translate(0 2.2)" fill="#02160C" />
        <polygon points={HEX} fill={`url(#${u("glass")})`} stroke={`url(#${u("frame")})`} strokeWidth="2.4" strokeLinejoin="round" />
        <polygon points="32,7.5 53,19.8 53,44.2 32,56.5 11,44.2 11,19.8" fill="none" stroke="#fff" strokeOpacity=".09" strokeWidth="1" />
        <g clipPath={`url(#${u("clip")})`}>
          <polygon points={BLUE} transform="translate(0.6 2.2)" fill="#002E7A" />
          <polygon points={BLUE} fill={`url(#${u("blue")})`} />
          <path d={GREEN} transform="translate(1 2.2)" fill="#005C26" />
          <path d={GREEN} fill={`url(#${u("green")})`} stroke="#050A0F" strokeWidth="2.2" strokeLinejoin="round" paintOrder="stroke" />
          <path d={GREEN} fill="none" stroke="#fff" strokeOpacity=".35" strokeWidth=".6" strokeLinejoin="round" />
          <polygon points="32,3 57,17.5 57,25 7,31 7,17.5" fill={`url(#${u("gloss")})`} />
          <rect x="-30" y="-10" width="18" height="90" fill={`url(#${u("shine")})`} transform="rotate(25 32 32)">
            <animate attributeName="x" values="-30;90;90" keyTimes="0;.45;1" dur="5s" repeatCount="indefinite" />
          </rect>
        </g>
        <circle cx="49" cy="15" r="1.6" fill="#EFFFF6" className="rx-mark-spark" />
      </svg>
    </span>
  );
}

export default function Logo3D({ size = 34, wordmark = true, textClass = "text-lg", testId = "brand-logo" }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid={testId}>
      <LogoMark size={size} />
      {wordmark && (
        <span className={`rx-wordmark ${textClass}`}>
          <span className="rx-chrome">ROBO</span><b>-X</b>
        </span>
      )}
    </span>
  );
}
